import React, { useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import { useQuery, useMutation } from "react-apollo-hooks";
import {
  CHARGEREQUEST_LIST_QUERY,
  CHARGEREQUEST_APPROVAL_QUERY,
  CHARGEREQUEST_CANCEL_QUERY,
} from "../../Queries";
import useInput from "../../../../../Hooks/useInput";
import Presenter from "./Presenter/List";
import qs from "qs";
import Moment from "moment";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import {
  commonStatusName,
  pay_methodName,
  datePlus9,
} from "../../../../../Components/User/UserNames";

export default withRouter(({ history, match, location, config }) => {
  const queryString = qs.parse(location.search.substr(1));

  const commonStatus = queryString.commonStatus;
  const pay_method = queryString.pay_method;
  var page = queryString.page ? queryString.page : 1;
  const startSearchDate = queryString.startSearchDate
    ? queryString.startSearchDate
    : "2020-09-01";
  const endSearchDate = queryString.endSearchDate
    ? queryString.endSearchDate
    : Moment().format("YYYY-MM-DD");
  var keyword = queryString.keyword ? queryString.keyword : "";
  const keywordInput = useInput(keyword);

  const blockSize = 5;
  const first = 15;
  const skip = first * (page - 1);
  const baseUrl =
    "?" +
    (commonStatus ? "commonStatus=" + commonStatus + "&" : "") +
    (pay_method ? "pay_method=" + pay_method + "&" : "") +
    (keywordInput.value ? "keyword=" + keywordInput.value + "&" : "") +
    (startSearchDate ? "startSearchDate=" + startSearchDate + "&" : "") +
    (endSearchDate ? "endSearchDate=" + endSearchDate + "&" : "");

  const { data, loading } = useQuery(CHARGEREQUEST_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      commonStatus,
      pay_method,
      startSearchDate,
      endSearchDate,
      keyword,
      skip,
      first,
    },
  });

  const [userListMutation] = useMutation(CHARGEREQUEST_LIST_QUERY);

  const [chargeRequestApproval] = useMutation(CHARGEREQUEST_APPROVAL_QUERY, {
    refetchQueries: () => [
      {
        query: CHARGEREQUEST_LIST_QUERY,
        variables: {
          commonStatus,
          pay_method,
          startSearchDate,
          endSearchDate,
          keyword,
          skip,
          first,
        },
      },
    ],
  });
  const [chargeRequestCancel] = useMutation(CHARGEREQUEST_CANCEL_QUERY, {
    refetchQueries: () => [
      {
        query: CHARGEREQUEST_LIST_QUERY,
        variables: {
          commonStatus,
          pay_method,
          startSearchDate,
          endSearchDate,
          keyword,
          skip,
          first,
        },
      },
    ],
  });
  const [csvData, setCsvData] = useState([]);
  const downloadButton = useRef();

  const handleDateApplyEvent = (event, picker) => {
    // event.preventDefault();

    var startDate = picker.startDate.format("YYYY-MM-DD");
    var endDate = picker.endDate.format("YYYY-MM-DD");

    const uri =
      "?" +
      (commonStatus ? "commonStatus=" + commonStatus + "&" : "") +
      (pay_method ? "pay_method=" + pay_method + "&" : "") +
      (keywordInput.value ? "keyword=" + keywordInput.value + "&" : "") +
      (startDate ? "startSearchDate=" + startDate + "&" : "") +
      (endDate ? "endSearchDate=" + endDate + "&" : "");

    history.push(
      `/chargeRequestConfigs/${config.AdminChargeRequestConfig.id}/${uri}page=1`
    );
  };

  const onStartDateSelect = (date) => {
    var date = Moment(date).format("YYYY-MM-DD");

    const uri =
      "?" +
      (commonStatus ? "commonStatus=" + commonStatus + "&" : "") +
      (pay_method ? "pay_method=" + pay_method + "&" : "") +
      (date ? "startSearchDate=" + date + "&" : "") +
      (endSearchDate ? "endSearchDate=" + endSearchDate + "&" : "") +
      (keywordInput.value ? "keyword=" + keywordInput.value + "&" : "");

    history.push(`${uri}page=1`);
  };
  const onEndDateSelect = (date) => {
    var date = Moment(date).format("YYYY-MM-DD");

    const uri =
      "?" +
      (commonStatus ? "commonStatus=" + commonStatus + "&" : "") +
      (pay_method ? "pay_method=" + pay_method + "&" : "") +
      (startSearchDate ? "startSearchDate=" + startSearchDate + "&" : "") +
      (date ? "endSearchDate=" + date + "&" : "") +
      (keywordInput.value ? "keyword=" + keywordInput.value + "&" : "");

    history.push(`${uri}page=1`);
  };
  const onPeriodConfig = (e) => {
    var startDate = null;
    var endDate = null;
    if (e.target.value === "ALL") {
    }
    if (e.target.value === "1W") {
      startDate = Moment().subtract(1, "w").format("YYYY-MM-DD");
      endDate = Moment().format("YYYY-MM-DD");
    }
    if (e.target.value === "1M") {
      startDate = Moment().subtract(1, "M").format("YYYY-MM-DD");
      endDate = Moment().format("YYYY-MM-DD");
    }
    if (e.target.value === "3M") {
      startDate = Moment().subtract(3, "M").format("YYYY-MM-DD");
      endDate = Moment().format("YYYY-MM-DD");
    }
    if (e.target.value === "6M") {
      startDate = Moment().subtract(6, "M").format("YYYY-MM-DD");
      endDate = Moment().format("YYYY-MM-DD");
    }

    const uri =
      "?" +
      (commonStatus ? "commonStatus=" + commonStatus + "&" : "") +
      (pay_method ? "pay_method=" + pay_method + "&" : "") +
      (startDate ? "startSearchDate=" + startDate + "&" : "") +
      (endDate ? "endSearchDate=" + endDate + "&" : "") +
      (keywordInput.value ? "keyword=" + keywordInput.value + "&" : "");

    history.push(`${uri}page=1`);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    history.push(
      `/chargeRequestConfigs/${config.AdminChargeRequestConfig.id}/chargeRequests${baseUrl}page=1`
    );
  };

  const DownloadButton = () => {
    const handleDownload = async () => {
      let data = [["상태", "방법", "이름", "아이디", "금액", "결제일시"]];
      try {
        const {
          data: { AdminChargeRequestList },
        } = await userListMutation({
          variables: {
            commonStatus,
            pay_method,
            startSearchDate,
            endSearchDate,
            keyword,
          },
        });
        AdminChargeRequestList.chargeRequests.forEach((chargeRequest) => {
          data.push([
            `${commonStatusName(chargeRequest.commonStatus)}`,
            `${pay_methodName(chargeRequest.pay_method)}`,
            chargeRequest.user.name,
            chargeRequest.user.userId,
            chargeRequest.amount,
            `${datePlus9(chargeRequest.createdAt)}`,
          ]);
        });
        setCsvData(data);
        downloadButton.current.link.click();
      } catch (e) {
        console.log(e);
        toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
      }
    };
    return (
      <>
        <button
          className="btn btn-white btn-block mr-2 text-truncate m-b-5"
          onClick={handleDownload}
        >
          <i className="fa fa-download fa-fw"></i>
        </button>
        <CSVLink
          data={csvData}
          filename={`충전내역.csv`}
          className="btn btn-white text-black hide"
          ref={downloadButton}
        >
          <i className="fa fa-download fa-fw"></i>
        </CSVLink>
      </>
    );
  };

  const handleApproval = async (e, item) => {
    e.preventDefault();

    try {
      await chargeRequestApproval({
        variables: {
          id: item.id,
        },
      });
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  const handleCancel = async (e, item) => {
    e.preventDefault();

    try {
      await chargeRequestCancel({
        variables: {
          id: item.id,
        },
      });
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      config={config}
      commonStatus={commonStatus}
      pay_method={pay_method}
      startSearchDate={startSearchDate}
      endSearchDate={endSearchDate}
      keyword={keyword}
      keywordInput={keywordInput}
      page={page}
      blockSize={blockSize}
      first={first}
      baseUrl={baseUrl}
      data={data}
      loading={loading}
      onStartDateSelect={onStartDateSelect}
      onEndDateSelect={onEndDateSelect}
      onPeriodConfig={onPeriodConfig}
      handleDateApplyEvent={handleDateApplyEvent}
      handleSearch={handleSearch}
      DownloadButton={DownloadButton}
      handleApproval={handleApproval}
      handleCancel={handleCancel}
    ></Presenter>
  );
});
